import React from "react"
import styled from "styled-components"
import { Modal } from "@prosolve/common-components-ui"
import EmailAttachmentButton from "./EmailAttachmentButton"
import SendEmailForm from "./EmailSendForm"

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
`

const FieldName = styled.span`
  font-weight: bold;
`

const AttachmentWrapper = styled.div`
  display: flex;
  gap: 10px;
`

const EmailWrapper = styled.div`
  flex: 1;
  border: solid 1px silver;
  border-radius: 5px;
  padding: 10px;
`

const SeamlessIframe = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;
`

export default ({
  email: emailProp,
  header,
  footer,
  onClose,
}) => {
  const {
    contents,
    from,
    subject,
    to,
    attachments
  } = emailProp || {}

  return (
    <Modal title='Email Preview' onClose={onClose}>
      <Contents>
        {header}

        <div><FieldName>To:</FieldName> {to}</div>
        <div><FieldName>From:</FieldName> {from}</div>
        <div><FieldName>Subject:</FieldName> {subject}</div>
        <div><FieldName>Attachments:</FieldName></div>
        <AttachmentWrapper>
          {attachments?.length > 0 && attachments.map(a => 
            <EmailAttachmentButton attachment={a} />
          )}
        </AttachmentWrapper>

        <div><FieldName>Body:</FieldName></div>
        <EmailWrapper>
          <SeamlessIframe srcDoc={contents} />
        </EmailWrapper>
        
        {footer}

        {!footer &&
          <SendEmailForm email={emailProp} />
        }
      </Contents>
    </Modal>
  )
}
